import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./style.css";

export default function Notification() {
  return (
    <ToastContainer
      limit={3}
      hideProgressBar={true}
      toastClassName={"custom-toast"}
    />
  );
}
